import TripleRule from './model/rule/TripleRule.js';
import { SPORule } from './model/rule/SPORule.js';
export const rules = [
    TripleRule,
    SPORule,
];
